<template>
    <el-dialog
            :title="title"
            :visible.sync="showFlag"
            width="30%"
            @close="closeDialog"
    >
        <div class="icon-box">
            <div class="file">
                <el-image slot="trigger" :src="imageUrl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
                <input ref="pathClear" type="file" @change="tirggerFile($event)"/>
            </div>
        </div>
        <div style="position: relative">
        <el-form ref="userForm" :model="form" :rules="rules" label-width="90px">
            <el-form-item label="账号类型" prop="role" v-if="isAdmin" v-show="!readOnly">
                <el-radio-group v-model="form.role">
                    <el-radio :label="0">管理员</el-radio>
                    <el-radio :label="3">采购员</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="所属公司" prop="compCode" v-show="form.role === 3">
                <el-select multiple v-model="form.compNoList" placeholder="请选择所属公司" style="display:block;">
                    <el-option
                            v-for="item in compList"
                            :key="item.compCode"
                            :label="item.compName"
                            :value="item.compCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采购组" prop="purGroup" v-show="form.role === 3">
                <el-select multiple v-model="form.purGroupList" placeholder="请选择所负责采购组" style="display:block;">
                    <el-option
                            v-for="item in groupList"
                            :key="item.hideValue"
                            :label="item.hideValue + ' ' +item.showText"
                            :value="item.hideValue">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采购类型" prop="compCode" v-show="form.role === 3">
                <el-radio-group v-model="form.isPleader">
                    <el-radio :label="0">普通采购员</el-radio>
                    <el-radio :label="1">超级采购员</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="账号" prop="username">
                <el-input v-model="form.username" placeholder="请输入账号" :readonly="readOnly" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="manname">
                <el-input v-model="form.manname" placeholder="请输入姓名" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="state">
                <el-radio-group v-model="form.isFreeze">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">冻结</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="联系方式" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入联系方式" maxlength="19"></el-input>
            </el-form-item>
        </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        name: 'userDialog',
        props: ['title'],
        computed: {
            ...mapState('login', ['isAdmin']),
        },
        data() {
            return {
                readOnly: false,
                imageUrl: '',
                showFlag: false,
                compList: [],
                groupList: [],
                form: {
                    type: 1,
                    username: '',
                    manname: '',
                    isFreeze: 0,
                    vendorNo: '',
                    smallAvatar: '',
                    role: 0,
                    isPleader: 0,
                    compNoList: [],
                    mobile: '',
                    file: {}
                },
                rules: {
                    username: [
                        { required: true, message: '请输入账户', trigger: 'blur' },
                        { min: 4, max: 30, message: '长度在 4 到 30 个字符', trigger: 'blur' },
                    ],
                }
            }
        },
        methods: {
            show(row) {
                this.showFlag = true;
                this.loadCompList();
                this.loadGroupList();
                if(row) {
                    console.log(row);
                    this.readOnly = true;
                    this.form = row;
                    if(row.compNo){
                        this.form.compNoList = row.compNo.split(",");
                    }
                    if(row.purGroup){
                        this.form.purGroupList = row.purGroup.split(",");
                    }
                    if(row.smallAvatar && row.smallAvatar !== '') {
                        this.imageUrl = 'data:image/jpg;base64,' + row.smallAvatar;
                    }
                }
            },
            submitForm() {
                this.$refs.userForm.validate((valid,err) => {
                    if (!valid) {
                        return false;
                    }
                    if(this.form.role === 3) {
                        if(!this.form.compNoList || this.form.compNoList.length === 0) {
                            this.$message.error("请选择所属公司");
                            return false;
                        }
                    }
                    delete this.form.createTime;
                    delete this.form.modifyTime;
                    delete this.form.smallAvatar;

                    if(!this.form.file || !this.form.file.size) {
                        delete this.form.file;
                    }

                    //提交
                    this.$store.dispatch('system/user/save',this.form).then((res) => {
                        if(res.code === '200') {
                            this.$message.success("操作成功");
                            this.imageUrl = '';
                            this.$emit('closeHandler');
                            this.closeDialog();
                        } else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                });
            },
            clearSelect() {
                this.form.vendorNo = '';
                this.form.vendorName = '';
            },
            closeDialog() {
                this.readOnly = false;
                this.imageUrl = '';
                this.$refs.pathClear.value ='';
                this.$refs.userForm.resetFields();

                this.form = {
                    type: 1,
                        username: '',
                        manname: '',
                        isFreeze: 0,
                        vendorNo: '',
                        smallAvatar: '',
                        role: 0,
                        isPleader: 0,
                        compNoList: [],
                        mobile: '',
                        file: {}
                },

                // this.form = {
                //     type: 1,
                //     username: '',
                //     password: '',
                //     manname: '',
                //     isFreeze: 1,
                //     vendorNo: '',
                //     vendorName: '',
                //     smallAvatar: '',
                //     role: 0,
                //     mobile: '',
                //     file: {}
                // };
                this.showFlag = false;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' ||
                    file.raw.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 1;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 1MB!');
                }
                return isJPG && isLt2M;
            },
            tirggerFile(event) {
                if (!event || !window.FileReader) return; // 看支持不支持FileReader
                var file = event.target.files[0];
                if(!this.beforeAvatarUpload(file)) {
                    return;
                }
                this.form.file = file;
                var freader = new FileReader();
                freader.readAsDataURL(file);
                freader.onload = (e) => {
                    this.imageUrl = freader.result;
                };
            },
            loadCompList() {
                this.$store.dispatch('system/user/compList').then((res) => {
                    if(res.code === '200') {
                        this.compList = res.data;
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                });
            },
            loadGroupList() {
                this.$store.dispatch('system/user/groupList').then((res) => {
                    if(res.code === '200') {
                        this.groupList = res.data;
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                });
            }
        }
    };
</script>
<style scoped>
    .icon-box {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }
    .icon-box .avatar-uploader {
        width: 100px;
        height: 100px;
        margin: 0 auto;
        cursor: pointer;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid gainsboro;
        font-size: 25px;
    }
    .icon-box .el-image {
        margin: 0 auto;
        cursor: pointer;
        text-align: center;

    }
    .file {
        width: 100px;
        height: 100px;
        position: relative;
        overflow: hidden;
        font-size: 25px;
        border: 1px solid gainsboro;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .file input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
        cursor: pointer;
    }
</style>